import { Component, OnInit } from '@angular/core';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetalleEstablecimientoService } from '../../../funcionario/opciones/establecimiento/establecimiento.service';
import { ActividadEconomicaEntry } from 'src/app/shared/entrys/actividad-economica.entry';
// tslint:disable-next-line:max-line-length
import { ModalActividadEconomicaComponent } from 'src/app/components/seguridad/layouts/modal-actividad-economica/modal-actividad-economica.component';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';

@Component({
	selector: 'app-establecimiento',
	templateUrl: './establecimiento.component.html',
	styleUrls: ['./establecimiento.component.scss']
})
export class EstablecimientoConsultaExternaComponent implements OnInit {
	suscripcion: Subscription;
	informacionEstablecimiento: any;
	tipo_rnt_inmueble = TipoRnt.Inmuebles;
	tipo_rnt_establecimiento = TipoRnt.Establecimiento;
	tipo_rnt_guia = TipoRnt.Guia;
	constructor(private dataSharedService: DataSharedService, private detalleEstablecimientoService: DetalleEstablecimientoService,
		private modalService: NgbModal) {
		this.informacionEstablecimiento = {};
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.informacionEstablecimiento = dataShared;
		});
	}

	ngOnInit() {
	}

	consultarActividades(entry: any) {
		this.detalleEstablecimientoService.getActividadesEconomicasParaFuncionario(entry.rnt_id)
			.subscribe(resultado => {
				if (resultado.result) {
					const actividadesEconomicas = resultado.data as Array<ActividadEconomicaEntry>;
					const modalRef = this.modalService.open(ModalActividadEconomicaComponent,
						{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
					modalRef.componentInstance.actividadesEconomicas = actividadesEconomicas;
				}
			});
	}
}
